
import { defineComponent, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import MensagemService from "@/core/services/MensagemService";

export default defineComponent({
  name: "Paginacao-Componente",
  props: {
    paginas: {
      type: Object,
      required: true,
    },
    paginaAtual: {
      type: Number,
      default: 1,
    },
    existeBotaoVoltar: {
      type: Boolean,
      default: false,
    },
    urlDestino: {
      type: String,
      default: "",
    },
    removeFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();

    const computedPages = computed(() => {
      return Array.from(Array(props.paginas.ultimaPagina).keys()).map(
        (x) => x + 1
      );
    });

    const hasPages = computed(() => {
      return Object.entries(props.paginas);
    });

    const loading = ref(true as boolean);
    const current_page = ref(1 as number);

    function validationCurrentPage(index) {
      return (
        (index >= 1 && index <= 3) ||
        (index >= props.paginaAtual - 2 &&
          index <= props.paginaAtual + 2 &&
          index > 3 &&
          index < props.paginas.ultimaPagina - 2) ||
        index >= props.paginas.ultimaPagina - 2 ||
        index == props.paginas.ultimaPagina
      );
    }

    function retornar() {
      MensagemService.retorno({
        texto: "Tem certeza que deseja voltar ?",
        rota: props.urlDestino + (!route?.params?.id ? "" : route?.params?.id),
      });
    }

    function changePage(index) {
      if (index != props.paginaAtual) {
        current_page.value = index;
        emit("set-pagination", current_page.value);
      }
    }

    return {
      computedPages,
      loading,
      current_page,
      validationCurrentPage,
      hasPages,
      changePage,
      retornar,
    };
  },
});
